<template>
  <div id="consulting-box">
    <h3 class="center">Planung und Beratung</h3>
    <h4 class="center">Wir erschaffen langlebige Unikate, deshalb geben wir eine Garantie auf all unsere Produkte.</h4>
    <br>
    <p>Mit großem Engagement und Begeisterung erfüllen wir die Wünsche unserer Kunden. Wir stellen uns Herausforderungen und suchen gemeinsam mit Ihnen nach der perfekten Lösung. Wir beraten, planen und lassen Raum für Kreativität.</p>
    <div class="grid grid-24 consulting-grid">
      <img class="justify-center col-0 above-sm-col-span-8 below-md-fill img-frame" src="@/assets/media/consulting/img1.jpeg"/>
      <div class="align-center col-0 above-sm-col-9 fill">
        <p>Nach einer umfassenden Beratung bei Ihnen zu Hause oder in unseren Büroräumlichkeiten erstellen wir einen Kostenvoranschlag sowie eine Planungsskizze.</p>
        <p>Dabei richten wir uns ganz nach Ihren Designvorstellungen und beraten sie bei der Realisierbarkeit und passenden Materialauswahl.</p>
      </div>

      <img class="justify-center col-0 above-sm-col-span-8 below-md-fill img-frame" src="@/assets/media/consulting/img2.jpeg"/>
      <div class="align-center col-0 above-sm-col-9 fill">
        <p>Die Planungsskizze setzen wir dann in Handarbeit in unserer Schreinerei um. Dabei setzen wir auf die Verarbeitung hochwertiger, zertifizierter und nachhaltiger Materialien namhafter Hersteller.</p>
        <p>Im letzten Schritt vereinbaren wir mit Ihnen einen Wunschtermin und kommen bei Ihnen für die Lieferung und die Installation vorbei. </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Consulting",
  data() {
    return {};
  }
};
</script>

<style>
#consulting-box > .grid.consulting-grid{
  grid-row-gap: 16px;
}
</style>
